//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    implantType: {
      type: Array,
      default() {
        return []
      },
    },
    gender: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    image: {
      type: Object,
      default() {},
    },
    location: {
      type: Object,
      default() {},
    },
    nickName: {
      type: String,
      default: '',
    },
    avatarUrl: {
      type: String,
      default: '',
    },
    shortDescription: {
      type: String,
      default: '',
    },
    aboutMentor: {
      type: String,
      default: '',
    },
    speakingLanguages: {
      type: [String, Array],
      default() {},
    },
    isLandingpage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isExpanded: false,
    }
  },
  methods: {
    truncateText(text) {
      const words = text.split(' ')
      if (words.length > 25) {
        return words.slice(0, 25).join(' ') + '...'
      } else {
        return text
      }
    },
    expandCard() {
      if (this.avatarUrl) {
        this.isExpanded = true
      }
    },
    collapseCard() {
      if (this.avatarUrl) {
        this.isExpanded = false
      }
    },
    toggleCard() {
      if (this.avatarUrl) {
        this.isExpanded = !this.isExpanded
      }
    },
    openMentorsForm() {
      if (this.userBranch !== '') {
        // eslint-disable-next-line no-undef
        const currentPageURL = window.location.href
        // eslint-disable-next-line no-undef
        window._mtm = window._mtm || []
        // eslint-disable-next-line no-undef
        window._mtm.push({
          event: 'get-in-touch-form-submission-start',
          'event-category': 'get-in-touch-form-submission',
          'event-action': `CLICK_LINK_URL - ${currentPageURL}`,
        })
      }

      this.$store.commit('global/setDialog', {
        dialog: 'contact-mentor',
        layer: true,
        props: {
          focus: {
            type: 'mentor',
            id: this.id,
            firstName: this.firstName,
            lastName: this.lastName,
          },
        },
      })
    },
  },
}
